import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../../data/content';
import { CTAButton } from '../CTAButton';
export function BeforeAfter() {
  return <section className="bg-cream py-14 sm:py-20" data-id="element-80" data-mp="26lutcc89j2bx">
      <div className="mx-auto w-full max-w-4xl px-4" data-id="element-81" data-mp="26mmbak8xt1jq">
        <h2 className="text-center font-display text-[27px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-82" data-mp="22lkba1774lgp">
          From “I know what I want to move… but where do I start?” to a structured biomechanical analysis
        </h2>

        <div className="mt-9 grid gap-4 md:grid-cols-2" data-id="element-83" data-mp="2ucgmkxdlyi1v">
          <div className="flex h-full flex-col rounded-2xl bg-white p-5 ring-1 ring-red-200 sm:p-6" data-id="element-84" data-mp="2q9u25hj9nzep">
            <div className="flex items-center gap-2 border-b border-red-100 pb-4" data-id="element-85" data-mp="2lbsa473v4pr3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-red-100" data-id="element-86" data-mp="1eux1fadpzlri">
                <XIcon className="h-4 w-4 text-red-600" aria-hidden="true" data-id="element-87" data-mp="19wddx5jha1x1" />
              </span>
              <h3 className="text-sm font-extrabold uppercase tracking-[0.12em] text-red-600 sm:text-base" data-id="element-88" data-mp="175m2z00398c3">
                Before
              </h3>
            </div>
            <ul className="mt-4 space-y-3.5" data-id="element-89" data-mp="1c3num9bkyfz6">
              {beforeItems.map(item => <li key={item} className="flex gap-3" data-id="element-90" data-mp="y4eh5herdzyw">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-500" aria-hidden="true" data-id="element-91" data-mp="13397d4f22qt1" />
                  <span className="text-[14.5px] leading-relaxed text-navy-800/85 sm:text-[15px]" data-id="element-92" data-mp="oecr4k2ui7hc">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="flex h-full flex-col rounded-2xl bg-navy-900 p-5 ring-1 ring-navy-900 sm:p-6" data-id="element-93" data-mp="fe6kni5ke7ro">
            <div className="flex items-center gap-2 border-b border-white/15 pb-4" data-id="element-94" data-mp="jficlubwv531">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-gogreen-500/20" data-id="element-95" data-mp="jdfa4atknjhf">
                <CheckIcon className="h-4 w-4 text-gogreen-500" aria-hidden="true" data-id="element-96" data-mp="af3nejvtt5u9" />
              </span>
              <h3 className="text-sm font-extrabold uppercase tracking-[0.12em] text-gogreen-500 sm:text-base" data-id="element-97" data-mp="2c40uemcojg40">
                With Mechanics Decision Map™
              </h3>
            </div>
            <ul className="mt-4 space-y-3.5" data-id="element-98" data-mp="23byy909n8lzj">
              {afterItems.map(item => <li key={item} className="flex gap-3" data-id="element-99" data-mp="239l18lvekzpc">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gogreen-500" aria-hidden="true" data-id="element-100" data-mp="1ye5qw3wltlxo" />
                  <span className="text-[14.5px] leading-relaxed text-white/85 sm:text-[15px]" data-id="element-101" data-mp="2v1u0tymii865">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-9 max-w-xl" data-id="element-102" data-mp="2m1dywtlf393e">
          <CTAButton label="I want a structured system" data-id="element-103" data-mp="2m49wggtcrvrb" />
        </div>
      </div>
    </section>;
}